export default __webpack_public_path__ + "static/media/699.6df59118.png";